<template>
  <div :id="$attrs['id']" :class="[[$attrs['class'], gridClasses], {'hm-season-color-picker--disabled': disabledCombined}]" class="hm-season-color-picker">
    <div class="hm-season-color-picker__options">
      <template v-for="color in colors">
        <div :class="{'active': internalValue === `#${color}` }" class="hm-season-color-picker__option" @click="toggleState(`#${color}`)">
          <span :class="`hm-season-color-picker__option__color hm-season-color-picker__option__color--${color}`"></span>
        </div>
      </template>
    </div>
    <div class="hm-season-color-picker__help" v-html="help" />
    <div class="hm-season-color-picker__label" v-html="label" />
  </div>
</template>

<script>

import HmInputMixin from '@/mixins/HmInputMixin';
import GridMixin from '@/mixins/GridMixin';
import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';

export default {
  name: 'HmSeasonColorPicker',

  mixins: [HmInputMixin, GridMixin, HotelmeisterMixin],

  data: function () {
    return {
      colors: [
        'f0bc5f',
        'd2a046',
        'a8791f',
        'f28e5e',
        'd17243',
        'b55a2d',
        'fb6a65',
        'd13e42',
        'c12d37',
        'e95aa1',
        'd0408c',
        'ae166e',
        'cf64f2',
        'ac44d2',
        '871aac',
        '61c8eb',
        '47b0d2',
        '1992b3',
        '4fadad',
        '188383',
        '0d5f60',
        '55cdaa',
        '23a785',
        '157c5d',
        'a9e55a',
        '96d248',
        '7fba30',
      ],
    };
  },

  methods: {
    toggleState: function (newValue) {
      if (!this.disabledCombined) {
        this.internalValue = this.internalValue === newValue ? null : newValue;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "~styles/import";


@mixin season-color-class($name, $color) {
  .hm-season-color-picker__option__color--#{$name} {
    background-color: rgba($color, 0.8);

    &:before {
      background-color: rgba($color, 0.4);
    }
  }
}

.hm-season-color-picker {
  position: relative;
  padding-top: 0.6rem;

  @include season-color-class("f0bc5f", #f0bc5f);
  @include season-color-class("d2a046", #d2a046);
  @include season-color-class("a8791f", #a8791f);
  @include season-color-class("f28e5e", #f28e5e);
  @include season-color-class("d17243", #d17243);
  @include season-color-class("b55a2d", #b55a2d);
  @include season-color-class("fb6a65", #fb6a65);
  @include season-color-class("d13e42", #d13e42);
  @include season-color-class("c12d37", #c12d37);
  @include season-color-class("e95aa1", #e95aa1);
  @include season-color-class("d0408c", #d0408c);
  @include season-color-class("ae166e", #ae166e);
  @include season-color-class("cf64f2", #cf64f2);
  @include season-color-class("ac44d2", #ac44d2);
  @include season-color-class("871aac", #871aac);
  @include season-color-class("61c8eb", #61c8eb);
  @include season-color-class("47b0d2", #47b0d2);
  @include season-color-class("1992b3", #1992b3);
  @include season-color-class("4fadad", #4fadad);
  @include season-color-class("188383", #188383);
  @include season-color-class("0d5f60", #0d5f60);
  @include season-color-class("55cdaa", #55cdaa);
  @include season-color-class("23a785", #23a785);
  @include season-color-class("157c5d", #157c5d);
  @include season-color-class("a9e55a", #a9e55a);
  @include season-color-class("96d248", #96d248);
  @include season-color-class("7fba30", #7fba30);

  &--disabled {
    pointer-events: none;

    .hm-season-color-picker {
      &__option {
        background-color: $lightgray;
        &__color {
          background-color: $middlegray !important;
          &:before {
            opacity: 0!important;
          }
        }
      }
    }
  }
  &__options {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    border: 0.1rem solid $middlegray;
    border-radius: 0.3rem;
    align-items: center;
    justify-items: center;
  }
  &__option {
    border-right: 0.1rem solid $middlegray;
    &:nth-child(8), &:nth-child(16), &:nth-child(24) {
      border-right: none;
    }
    &:nth-child(-n+8), &:nth-child(-n+16), &:nth-child(-n+24) {
      border-bottom: 0.1rem solid $middlegray;
    }
    width: 100%;
    display: grid;
    align-items: center;
    justify-items: center;
    padding: 0.8rem 0;
    &:hover {
      .hm-season-color-picker__option__color {
        &:before {
          opacity: 1;
        }
      }
    }
    &__color {
      width: 1.4rem;
      height: 1.4rem;
      border-radius: 50%;
      position: relative;
      &:before {
        content: "";
        position: absolute;
        width: 2rem;
        height: 2rem;
        border-radius: 50%;
        left: -0.3rem;
        top: -0.3rem;
        display: block;
        opacity: 0;
        transition: opacity 0.2s ease;
      }
    }

    &.active {
      .hm-season-color-picker__option__color {
        &:before {
          opacity: 1;
        }
      }
    }
    &:hover {
      cursor: pointer;
    }
  }
  &__help {
    color: $gray;
    font-size: 1.1rem;
    padding-left: 1rem;
    height: 1.4rem;
    line-height: 1.4rem;
    margin-bottom: 0.3rem;
    margin-top: 0.3rem;
  }
  &__label {
    position: absolute;
    top: 0;
    left: 0.6rem;
    font-size: 1.1rem;
    color: $gray;
    transition: all 0.2s ease;
    z-index: 2;
    pointer-events: none;
    background-color: $white;
    padding: 0 0.4rem;
    border-radius: 0.3rem;
    will-change: top, font-size;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/lib/inputs/HmSeasonColorPicker.vue